import { Component, State, Prop, Event, h, EventEmitter } from '@stencil/core';
import { overrideSettings } from '../../utils/utils';

@Component({
  tag: 'fdi-image-uploader',
  styleUrl: 'fdi-image-uploader.scss',
  shadow: true,
})
export class FdiImageUploader {

  @Prop() __settings: any;
  @Prop() __value: any;

  @State() src: any;
  @State() settings: any = {
    meta: {},
  };

  @Event({
    eventName: 'fdi_wc_image_uploader_load',
    bubbles: true,
    cancelable: true,
  }) imageUploader: EventEmitter

  emitData(){
    this.imageUploader.emit({
      src: this.src,
      meta: this.settings.meta,
    });
  }

  componentWillLoad(){
    let settings = this.__settings;
    if ( typeof settings === 'string' ){
      settings = JSON.parse( settings );
    }
    if ( this.__value ) {
      this.src = this.__value;
    }
    this.settings = overrideSettings( this.settings, settings );
  }

  selectImage() {
    // @ts-ignore
    let wordpress = wp || null;
    console.log({wordpress})
    if ( wordpress ) {
      let image_frame = wordpress.media({ 
        title: 'Select Image',
        multiple: false,
        library: {
            type: 'image'
        }
      });
      image_frame.on( 'open', function() {
          var lastSelection = image_frame.state().get( 'selection' );
          const attach = wordpress.media.attachment( lastSelection._single.id );
          if ( attach ) {
              attach.fetch();
          }
          lastSelection.add( attach ? [attach] : [] );
      });
      image_frame.on( 'select', function () {
          let selection = image_frame.state().get('selection');
          var metadata = image_frame.state().get('selection').first().toJSON();
          console.log({selection, metadata})
          selection.each(function (attachment) {
              let attrs = attachment["attributes"];
              if ( !attrs.alt ) {
                  alert( `Alt text is required for ${attrs.filename} to select it.` );
                  image_frame.open();
              } else if ( metadata.url ) {
                this.src = {
                  media_library: {
                    id: metadata.id,
                    src: metadata.url
                  }
                }; 
                this.emitData(); 
              }
          }.bind( this ));
      }.bind( this ));
      image_frame.open();
    }
  }

  render() {
    return (
      <div>
        <div>
          <button type="button" onClick={ () => this.selectImage() }>Select Image</button>
        </div>
        <div id="image_uploader_preview">
          {this?.src?.media_library?.src && <img style={{maxHeight: '100%', maxWidth: '100%'}} src={this.src.media_library.src} />}
        </div>
      </div>
    );
  }
}
